"use strict";

var utils = require("./utils.js");
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.string2binary = function (str) {
  return utils.string2binary(str);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.string2Uint8Array = function (str) {
  return utils.transformTo("uint8array", str);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.uint8Array2String = function (array) {
  return utils.transformTo("string", array);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.string2Blob = function (str) {
  var buffer = utils.transformTo("arraybuffer", str);
  return utils.arrayBuffer2Blob(buffer);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.arrayBuffer2Blob = function (buffer) {
  return utils.arrayBuffer2Blob(buffer);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.transformTo = function (outputType, input) {
  return utils.transformTo(outputType, input);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.getTypeOf = function (input) {
  return utils.getTypeOf(input);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.checkSupport = function (type) {
  return utils.checkSupport(type);
};
/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */


exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */

exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */

exports.pretty = function (str) {
  return utils.pretty(str);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.findCompression = function (compressionMethod) {
  return utils.findCompression(compressionMethod);
};
/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */


exports.isRegExp = function (object) {
  return utils.isRegExp(object);
};


//////////////////
// WEBPACK FOOTER
// ./~/pizzip/js/deprecatedPublicUtils.js
// module id = 1576
// module chunks = 2